import { writable } from 'svelte/store';

export const commandLineVisible = writable(false);
